import { FormatStateStore } from 'common/stores/FormatStateStore';
import {
  UserClickHandler,
  UserClickHandlerProps
} from 'common/stores/handlers/UserClickHandler';
import { MonitoringStore } from 'common/stores/MonitoringStore';
import { SkanStore } from 'common/stores/SkanStore';

import { ImageDisplayUserClickHandler } from './handlers/ImageDisplayUserClickHandler';
import {
  MraidUserClickHandler,
  MraidClickHandlerProps
} from './handlers/MraidUserClickHandler';

interface Props {
  adContext: AdContext;
  handlerProps: UserClickHandlerProps;
  formatStateStore: FormatStateStore;
}

export function getUserClickHandler(props: Props) {
  if (
    props.adContext.creativeSource === 'image' &&
    props.adContext.adUnitType === 'interstitial'
  ) {
    return new ImageDisplayUserClickHandler({
      ...props.handlerProps,
      monitoringStore: new MonitoringStore({
        mraidStore: props.handlerProps.mraidStore,
        formatStateStore: props.formatStateStore,
        analyticsStore: props.handlerProps.analyticsStore,
        formatContext: props.handlerProps.formatContext,
        formatConfig: props.handlerProps.formatConfig
      })
    });
  }

  if (props.adContext.creativeSource === 'redirect') {
    const mraidUserClickHandlerProp: MraidClickHandlerProps = {
      ...props.handlerProps
    };

    const hasSkan: boolean | undefined =
      props.adContext.skan && props.adContext.adUnitType === 'interstitial';

    if (hasSkan) {
      mraidUserClickHandlerProp.skanStore = new SkanStore({
        analyticsStore: props.handlerProps.analyticsStore,
        mraidStore: props.handlerProps.mraidStore
      });
    }

    return new MraidUserClickHandler(mraidUserClickHandlerProp);
  }

  return new UserClickHandler({
    ...props.handlerProps
  });
}
